export const PUBLIC_URL = process.env.REACT_APP_PUBLIC_URL
export const MEDIA_API_URL = process.env.REACT_APP_MEDIA_API_URL
export const DRUPAL_API_URL = process.env.REACT_APP_DRUPAL_API_URL
export const SEARCH_API_URL = process.env.REACT_APP_SEARCH_API_URL
export const RADAR_DATA_API_URL = process.env.REACT_APP_RADAR_DATA_API_URL
export const RADAR_DATA_WEBSOCKET_URL = process.env.REACT_APP_RADAR_DATA_WEBSOCKET_URL
export const NEWS_FEED_API_URL = process.env.REACT_APP_NEWS_FEED_API_URL
export const PHENOMENA_STATISTICS_API_URL = process.env.REACT_APP_PHENOMENA_STATISTICS_API_URL
export const TAG_SERVICE_API_URL = process.env.REACT_APP_TAG_SERVICE_API_URL
